import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ShipmentItemsActions } from '../StoreAdapter'
import { ShipmentItemSchema } from '../../../Schema/ShipmentItemSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ShipmentItemsAPI } from '../../../Services/API/ShipmentItemsAPI'

export const useUpdateShipmentItem = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const updateShipmentItem = useCallback(
    async (
      schema: Partial<ShipmentItemSchema>,
    ): Promise<ShipmentItemSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ShipmentItemsAPI)
        .updateEntity(schema)
        .then((schema) => {
          dispatch(ShipmentItemsActions.updateOne(schema))
          if (schema.isDelivered) {
            dispatch(
              ShipmentItemsActions.flagDeliveredByTrackingNumber({
                trackingNumber: schema.carrierTrackingNumber,
                deliveryDate: schema.deliveryDate,
                signedBy: schema.signedBy,
              }),
            )
          }
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    updateShipmentItem,
  }
}
